module.exports = __webpack_public_path__ + "static/media/4006868833093d06696ae39c73ba2ffb.40068688.mp4";